// extracted by mini-css-extract-plugin
module.exports = {"item-with-image":"item-with-image__4qZtf"};